import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';

function AppDropdown(props) {
  const {
    children,
    disabled,
    dropdownText,
    id,
  } = props;

  /* eslint-disable react/prop-types */
  /* istanbul ignore next */
  const CustomToggle = React.forwardRef(({ onClick }, ref) => (
    <button
      type="button"
      aria-label="dropdown toggle"
      id={id}
      tabIndex={0}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      onKeyPress={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      disabled={disabled}
      className="btn btn-secondary px-1 py-0"
      style={{ fontSize: '12px', fontWeight: 'bold' }}
    >
      {dropdownText ? `${dropdownText} ` : null}
      <FontAwesomeIcon icon={faAngleDown} />
    </button>
  ));

  /* istanbul ignore next */
  return (
    <>
      <Dropdown drop="down" style={{ maxHeight: '32px', alignSelf: 'center' }}>
        <Dropdown.Toggle as={CustomToggle} />
        <Dropdown.Menu>
          {React.Children.map(
            children, (child) => React.cloneElement(child, { disabled }),
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

AppDropdown.defaultProps = {
  disabled: false,
  dropdownText: '',
  id: 'dropdown-toggle',
};

AppDropdown.propTypes = {
  disabled: PropTypes.bool,
  dropdownText: PropTypes.string,
  id: PropTypes.string,
};

export default AppDropdown;
